/**
 * @module lib/calculate-monthly-payment
 */

/**
 * Calculates the max monthly mortgage payment the user can afford and adjusts requested DTI until a loan can be found.
 * @todo EM-3283 Do not "adjust"; just calculate error
 * @todo EM-3284 consistently use `MIN_MONTHLY_PAYMENT`
 * @param {object} inputs
 * @param {number} inputs.annualIncome  Annual income
 * @param {number} inputs.downPayment Overridden down payment for loan
 * @param {number} inputs.dti Requested debt-to-income ratio; recommended is 0.36
 * @param {number} inputs.monthlyDebt  Monthly debt obligations
 * @param {number} inputs.monthlyHoaDues Monthly Homeowners Association dues
 * @param {number} inputs.monthlyHomeownersInsurance The monthly homeowners insurance payment
 * @param {number} inputs.monthlyPropertyTax Monthly property tax
 * @param {string} inputs.state  2 character US state abbreviation
 * @param {number=} suggestedPurchasePrice  The purchase price (or output of this calc)
 * @param {number=} downPayment  The down payment from the last iteration of this calculation
 * @returns {number} The max monthly mortgage payment
 */
export default function calculateAdjustedMonthlyPayment(_ref, yearlyPropertyTax) {
  var annualIncome = _ref.annualIncome,
    dti = _ref.dti,
    monthlyDebt = _ref.monthlyDebt,
    monthlyHoaDues = _ref.monthlyHoaDues,
    monthlyHomeownersInsurance = _ref.monthlyHomeownersInsurance;
  var monthlyMortgagePayment = dti * (annualIncome / 12) - yearlyPropertyTax / 12 - monthlyHomeownersInsurance - monthlyHoaDues - monthlyDebt;
  return monthlyMortgagePayment;
}